import React from "react";

const UEFBaseNav = () => {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Welcome to the AI Generated Base Navigation Application!</h1>
        </div>
    );
};

export default UEFBaseNav;
